import styled from "styled-components";

export const Container = styled.div`
  background: white;
  border-radius: 20px;
  box-shadow: 0px 3px 10.4px 1px #9395cc3d;
  margin-bottom: 24px;
  border: 2px solid #fff;

  .block-header {
    padding: 20px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding-bottom: 20px;
    margin-bottom: 10px;
    background-color: #fafafc;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    .header-left {
      display: flex;
      flex-direction: column;

      .title {
        font-size: 20px;
        color: #1f1f52;
        font-family: "Nunito Sans Light";
        margin-bottom: 5px;
      }

      .cycle-selector {
        display: flex;
        flex-direction: column;
        margin-bottom: 8px;

        .selector-text {
          font-size: 16px;
          color: #4a5568;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 6px;

          i {
            font-size: 10px;
          }
        }

        .status-text {
          font-size: 14px;
          color: #2d39c4;
          font-weight: 600;
        }
      }

      .date-controls {
        font-size: 14px;
        color: #707582;
        font-family: "Nunito Sans";

        .action-text {
          margin-left: 5px;
          font-weight: 600;
          cursor: pointer;
        }
      }

      .subtitle {
        font-size: 12px;
        color: #1f1f52;
        font-weight: 700;
      }
    }

    .header-right {
      display: flex;
      align-items: center;

      .current-badge {
        background-color: #ffffff;
        padding: 4px 5px 5px 10px;
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 14px;
        border-radius: 15px;
        color: #707582;
        .avatar {
          width: 23px;
          height: 23px;
          border-radius: 50%;
        }
      }

      .completed-badge {
        display: flex;
        align-items: center;
        gap: 6px;
        background: #cfd3dd;
        color: #707582;
        padding: 4px 10px;
        border-radius: 12px;
        font-size: 17px;
        .icon {
          font-size: 11px;
        }
      }

      .locked-badge {
        display: flex;
        align-items: center;
        gap: 6px;
        background: #cfd3dd;
        color: #3e3e5b;
        border-radius: 27px;
        padding: 4px 5px 5px 10px;
        font-size: 17px;
      }
    }
  }

  .milestones-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
`;
